import { consolidationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";
export const cancelConsolidation = {
  name: "cancelConsolidation" as const,
  input: z.object({
    consolidationId: consolidationIdFormat.schema,
    reason: z.string().trim().min(1).max(500),
  }),
  output: z.object({ cancelledAt: z.date() }),
};
